
















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// Shared types
import { Floor, InsulationLevel, OutdoorUnitLocation } from '@coldtec/cos-types';

// Store types
import { SpacesConfigData, ToolSpace } from '@/store/store.types';

/**
 *  Component that reflects the configuration choices of the user at the top of the space.
 */
@Component
export default class SpaceSummary extends Vue {

    @Prop({ type: Object, required: true })
    private toolSpace!: ToolSpace;

    /**
     *  Used to get the data that is used to configure
     *  a space and is used in the summary.
     */
    private get configData(): SpacesConfigData {

        return this.$store.state.spaces.configData;

    }

    /**
     *  Used to get the contents of the space.
     */
    private get contents(): number | null {

        return this.toolSpace.data.contents === null ? null : this.toolSpace.data.contents;

    }

    /**
     *  Used to get the model of the selected floor.
     */
    private get floor(): Floor | null {

        return !this.toolSpace.data.floor
            ? null
            : this.configData.floors[this.toolSpace.data.floor];

    }

    /**
     *  Used to get the model of the selected insulation level.
     */
    private get insulationLevel(): InsulationLevel | null {

        return !this.toolSpace.data.insulation_level
            ? null
            : this.configData.insulation_levels[this.toolSpace.data.insulation_level];

    }

    /**
     *  Used to get the model of the selected floor.
     */
    private get outdoorUnitLocation(): OutdoorUnitLocation | null {

        return !this.toolSpace.data.outdoor_unit_location
            ? null
            : this.configData.outdoor_unit_locations[this.toolSpace.data.outdoor_unit_location];

    }

}
